import "./App.scss";
import React from "react";

function App() {
  return (
    <div>
      <h1>HOUExplorer</h1>
      <p>
        Howdy and welcome to the point of view (POV) transit channel in
        exploring places by riding the bus, train, plane, ferry, and other modes
        of transportation. My goal is for you to travel with confidence by
        sharing my experience in a personal point of view.
      </p>
      <p>
        More contents will be added to this site, in the meantime, please visit
        HOUExplorer's{" "}
        <a
          href="https://www.youtube.com/houexplorer"
          target="_blank"
          title="This will open HOUExplorer YouTube Channel"
          rel="noopener noreferrer"
        >
          YouTube Channel
        </a>{" "}
        or{" "}
        <a
          href="https://www.instagram.com/houexplorer"
          target="_blank"
          title="This will open @HOUExplorer Instagram profile."
          rel="noopener noreferrer"
        >
          Instagram
        </a>
        .
      </p>
      <h2>Cities visited</h2>
      <p>
        Below is a list of cities that I have visited and explored (linked with
        the Youtube's playlist):
      </p>
      <ul>
        <li>
          Arizona
          <ul>
            <li>
              <a
                href="https://www.youtube.com/watch?v=5ySvmfKiq94&list=PL3xclbLkhqRRtqcwOer8FLylJML5k_f96"
                target="_blank"
                title="This will open HOUExplorer YouTube Channel Phoenix Playlist"
                rel="noopener noreferrer"
              >
                Phoenix
              </a>
            </li>
          </ul>
        </li>
        <li>
          California
          <ul>
            <li>
              <a
                href="https://www.youtube.com/watch?v=37DK1B38bzM&list=PL3xclbLkhqRSS1_8khlG3faeMd1O32lu2"
                target="_blank"
                title="This will open HOUExplorer YouTube Channel Los Angeles Metro Playlist"
                rel="noopener noreferrer"
              >
                Los Angeles
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/watch?v=SxJqUUSDyA4&list=PL3xclbLkhqRQThM8sdhMkxINyqV8KlAu1"
                target="_blank"
                title="This will open HOUExplorer YouTube Channel San Diego MTS Metro Playlist"
                rel="noopener noreferrer"
              >
                San Diego
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/watch?v=OOL2AJX5AOc&list=PL3xclbLkhqRTHU94Ix3TxmpWTWQVOxGnt"
                target="_blank"
                title="This will open HOUExplorer YouTube Channel San Francisco BART and Muni Metro Playlist"
                rel="noopener noreferrer"
              >
                San Francisco
              </a>
            </li>
          </ul>
        </li>
        <li>
          Colorado
          <ul>
            <li>
              <a
                href="https://www.youtube.com/watch?v=wg2NzlTpcAY&list=PL3xclbLkhqRQuB245UDS7pses1NO5zx4-"
                target="_blank"
                title="This will open HOUExplorer YouTube Channel Denver RTD Playlist"
                rel="noopener noreferrer"
              >
                Denver
              </a>
            </li>
          </ul>
        </li>
        <li>
          Florida
          <ul>
            <li>
              <a
                href="https://www.youtube.com/watch?v=9rnKkXvMbOg&list=PL3xclbLkhqRQJ4ojxR64iYqo3iWtKJVPp"
                target="_blank"
                title="This will open HOUExplorer YouTube Channel Miami-Dade Transit and Broward County Metro Playlist"
                rel="noopener noreferrer"
              >
                Miami
              </a>
            </li>
          </ul>
        </li>
        <li>
          Georgia
          <ul>
            <li>
              <a
                href="https://www.youtube.com/watch?v=EkD9HY-0K48&list=PL3xclbLkhqRRRJPEFObMm6uPR7eO48Cqo"
                target="_blank"
                title="This will open HOUExplorer YouTube Channel Atlanta MARTA Playlist"
                rel="noopener noreferrer"
              >
                Atlanta
              </a>
            </li>
          </ul>
        </li>
        <li>
          North Carolina
          <ul>
            <li>
              <a
                href="https://www.youtube.com/watch?v=6IU5SkMmqA0&list=PL3xclbLkhqRS3XUahmsNFZVhzB4MYtSiS"
                target="_blank"
                title="This will open HOUExplorer YouTube Channel Charlotte CATS Playlist"
                rel="noopener noreferrer"
              >
                Charlotte
              </a>
            </li>
          </ul>
        </li>
        <li>
          New York
          <ul>
            <li>
              <a
                href="https://www.youtube.com/watch?v=sKRWRGm5jaM&list=PL3xclbLkhqRTiTqiJegO8zeUxnx1aJK5U"
                target="_blank"
                title="This will open HOUExplorer YouTube Channel New York City MTA Playlist"
                rel="noopener noreferrer"
              >
                New York City
              </a>
            </li>
          </ul>
        </li>
        <li>
          Pennsylvania
          <ul>
            <li>
              <a
                href="https://youtu.be/cbzCHDlkTmc"
                target="_blank"
                title="This will open HOUExplorer YouTube Channel SEPTA Playlist (joined with Northeast Corrdior)"
                rel="noopener noreferrer"
              >
                Philadelphia
              </a>
            </li>
          </ul>
        </li>
        <li>
          Texas
          <ul>
            <li>
              <a
                href="https://www.youtube.com/watch?v=gpxeWQR97aU&list=PL3xclbLkhqRTH3RKp18PFo-BlgfAHAlqI"
                target="_blank"
                title="This will open HOUExplorer YouTube Channel Austin CapMetro."
                rel="noopener noreferrer"
              >
                Austin
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/watch?v=KbRQcD5Yo9M&list=PL3xclbLkhqRRC_uZk-pFI0Kp94iZk8_B7"
                target="_blank"
                title="This will open HOUExplorer YouTube Channel Dallas DART, Fort Worth Trinity Metro"
                rel="noopener noreferrer"
              >
                Dallas-Fort Worth
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/watch?v=jzaY154y0vM&list=PL3xclbLkhqRQ36_5PUMarA42V749kv3U0"
                target="_blank"
                title="This will open HOUExplorer YouTube Channel Houston METRO Playlist"
                rel="noopener noreferrer"
              >
                Houston
              </a>
            </li>
          </ul>
        </li>
        <li>
          Utah
          <ul>
            <li>
              <a
                href="https://www.youtube.com/watch?v=HPh281sph08&list=PL3xclbLkhqRQkTaChwPzz2ukv_kcZJxJK"
                target="_blank"
                title="This will open HOUExplorer YouTube Channel UTA Playlist"
                rel="noopener noreferrer"
              >
                Salt Lake City
              </a>
            </li>
          </ul>
        </li>
        <li>
          <a
            href="https://www.youtube.com/watch?v=jicGvyO6lfo&list=PL3xclbLkhqRRv18ppYnGx5Z6oJoQmvxuI"
            target="_blank"
            title="This will open HOUExplorer YouTube Channel WMATA DC Metro Metro Playlist"
            rel="noopener noreferrer"
          >
            Washington, D.C.
          </a>
        </li>
      </ul>
      <h2>What does HOUExplorer means?</h2>
      <p>
        HOU means Houstonian and Explorer means to explore. I am a Houstonian
        that loves to explore cities using public transit, planes, passenger
        train, ferry, and other modes of transporation.
      </p>
    </div>
  );
}

export default App;
